/**
 * Purchase order line top stati.
 */
export default {
  TOP_DAMAGED: 'TOP Damaged',
  HAS_PHOTO: 'Has Photo',
  PHOTO_SHOOT_COMPLETE: 'Photo Shoot Complete',
  RECEIVED_BY_SAMPLE_COORDINATOR: 'Received By Sample Coordinator',
  RECEIVED: 'Received',
  CANCELLED: 'Cancelled',
  MOVED_TO_PHOTO_STUDIO: 'Moved to Photo Studio',
  SAMPLE_READY_FROM_PHOTOSHOOT: 'Sample Ready from PhotoShoot',
  PENDING_RECEIPT: 'Pending Receipt',
  REJECTED: 'Rejected',
  APPROVED: 'Approved',
  TOP_SAMPLE_READY_TO_PHOTO_STUDIO: 'TOP Sample Ready To Photo Studio',
  TOP_SAMPLE_BACK_FROM_PHOTO_STUDIO: 'TOP Sample Back From Photo Studio',
  TOP_SAMPLE_IN_SAMPLE_COORDINATION_TEAM:
    'TOP Sample In Sample Coordination Team',
};
